import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import looppa from 'looppa';
import { connect } from 'react-redux';
import reduxUtils from 'util/redux';
import Loader from 'components/loader';
import PickerTile from 'components/picker-tile';
import Slider from 'components/slider';
import sliderConfig from './slider-config';

class PickersSliderHighlight extends PureComponent {
    static propTypes = {
        pickers: PropTypes.array.isRequired,
        isMobile: PropTypes.bool.isRequired,
        isMainContentLoaded: PropTypes.bool.isRequired,
    };

    render() {
        const { pickers, isMainContentLoaded } = this.props;

        if (!isMainContentLoaded) {
            return <Loader/>;
        }

        return (
            <Slider facet="pickers-slider-highlight" config={sliderConfig}>
                {looppa(pickers)((picker, idx) => (
                    <PickerTile facet={'highlight'} {...picker} key={idx}/>
                ))}
            </Slider>
        );
    };
}

export default connect(
    reduxUtils.mapStateToProps({
        isMainContentLoaded: 'main-content.isLoaded',
        isMobile: 'viewport.isMobile',
    }),
    reduxUtils.mapDispatchToProps({}),
)(PickersSliderHighlight);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/pickers-slider-highlight/index.js